import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts'

interface Iprops {
  chatStatus: any
}

export const PieChart: React.FC<Iprops> = ({ chatStatus }) => {
  const [chartData, setChartData] = useState<any>({
    series: [
      Number(chatStatus?.totalConversationsResolvedByAllAgent) || 0,
      Number(chatStatus?.totalConversationsEscalatedByAllAgent) || 0
    ],
    chart: {
      type: 'pie'
    },
    labels: ['Resolved', 'Escalated'],

    plotOptions: {
      pie: {
        size: '200px'
      }
    },
    stroke: {
      show: false
    },
    dataLabels: {
      enabled: true,
      formatter(val: any, opts: any) {
        const name = opts.w.globals.labels[opts.seriesIndex]
        return [name, val.toFixed(1) + '%']
      }
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'left',
      markers: {
        width: 9,
        height: 9
      },
      itemMargin: {
        horizontal: 20,
        vertical: 0
      }
    },
    // Updated colors
    colors: ['#00E396', '#FF0000'] // Green, Blue, Red
  })

  useEffect(() => {
    setChartData({
      ...chartData,
      series: [
        Number(chatStatus?.totalConversationsResolvedByAllAgent) || 0,
        Number(chatStatus?.totalConversationsEscalatedByAllAgent) || 0
      ]
    })
  }, [chatStatus])

  return (
    <div className='col-xxl-4'>
      <div className='card'>
        <div className='card-header'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label'>CONVERSATION STATUS</span>
          </h3>
        </div>
        <div className='card-body'>
          <ReactApexChart
            options={chartData}
            series={chartData.series}
            type='pie'
            height={'440px'}
          />
        </div>
      </div>
    </div>
  )
}
